var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkaSaintPetersburg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 313.1 313.2",
    style: {
      enableBackground: "new 0 0 313.1 313.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#DD0332;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#DD0333;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M269.3,218H256v-36.3h13.3v-31.3h-17.6v108.3h-40.9l0.4-113.1l0-0.4c2.4-24,15.2-31.3,38-31.3h60.9l0.2,144.9 l-41.1,0V218z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M273.9,213.3h-13.3v-27h13.3v-40.6H247V254h-31.6l0.4-108.3l0-0.2c2.1-21.5,13-27.2,33.4-27.1h56.3l0.2,135.6 h-31.8V213.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M273.9,213.3h-13.3v-27h13.3v-40.6H247V254h-31.6l0.4-108.3l0-0.2c2.1-21.5,13-27.2,33.4-27.1h56.3l0.2,135.6 h-31.8V213.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M301.1,249.4L300.9,123h-51.7c-18.7,0-26.9,4.5-28.8,23l-0.4,103.4h22.3V141.1h36.2v49.8h-13.3v17.8h13.3v40.7 H301.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.8,194.9c0-2.9,0-14.7,0-17.6l0,0v-31.8c0-17.4,11-31.7,29.2-31.7h39.9c18.6,0,30.1,12.9,30.3,31.1l0,0.1 v27.5H61.2v-22.1H44v71.2h17.1v-26.4h41.1v31.6c0,18.2-11.7,31.3-30.3,31.3H32c-18,0-29-14-29.2-31.1v-0.1L2.8,194.9L2.8,194.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.5,199.5c0.1-4.5,0.1-9,0.1-13.4c0-4.5-0.1-9-0.1-13.4H7.5v-27.1c0-14.8,9-27,24.6-27h39.9 c16.1,0,25.5,10.9,25.7,26.5l0,23H65.8v-22.1H39.4v80.5h26.4V200h31.9v27c0,15.7-9.7,26.7-25.7,26.7H32 c-15.4,0-24.4-11.9-24.6-26.6V227l0-27.5H7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.4,199.5c0.1-4.5,0.1-22.4,0-26.9l0,0v-27.1c0-14.8,9-27,24.6-27h39.9c16.1,0,25.5,10.9,25.7,26.5l0,23H65.8 v-22.1H39.4v80.5h26.4V200h31.9v27c0,15.7-9.7,26.7-25.7,26.7H32c-15.4,0-24.4-11.9-24.6-26.6V227L7.4,199.5L7.4,199.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93,226.9v-22.3H70.4V231H34.8v-89.8h35.7v22.1H93v-18.3c-0.2-13.1-7.5-22-21.1-22H32c-13.1,0-20,10.2-20,22.4 V168l0,0c0.1,6,0.1,30.1,0,36.1l0,0l0,22.9c0.1,12.1,7.1,22,20,22h39.9C85.5,249,93,240,93,226.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.7,231.6c0.6,0.6,1.2,1.4,1.8,2.1c5.6,7.3,7.2,16.6,7.2,25.7v48.9h-40.2v-48.9c0-2.1,0.1-4.3,0-6.4 c-0.1-0.6-0.2-1.5-0.4-2.1c-0.4-1-3.2-1.1-4-1.2l-8.7-0.5l0.1-34.1l7.5-1.4c1-0.2,4.8-1,5.5-1.9c0.1-0.3,0.1-1,0.1-1.2v-47.5h40.2 v48.1C205.6,219.6,202.1,226.4,196.7,231.6 M107.3,163.1h40.2v145.2h-40.2V163.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M189.6,231.5c1.9,1.4,3.6,2.9,5.2,5.1c5,6.5,6.2,14.9,6.2,22.8v44.3h-30.9v-44.3c0-7.8,1.2-13.7-8.8-14.3 l-4.4-0.3l0-25.9l3.8-0.7c2.5-0.5,6.3-1.4,8.1-3.3c1.1-1.2,1.3-2.8,1.3-4.3v-42.9H201v43.5C201,220.1,196.2,226.8,189.6,231.5  M111.9,167.7h30.9v135.9h-30.9V167.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174.7,259.4c0-7,1.5-18-13.2-18.9l0-17.7c7.5-1.4,13.2-4.1,13.2-12.2v-38.2h21.7v38.9 c0,11.2-9.6,17.3-15.8,20.1c7,4.2,15.8,8,15.8,28.1V299h-21.7V259.4z M116.5,172.4h21.7V299h-21.7V172.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "174.9,64.6 237.5,64.5 186.8,101.2 206.3,160.7 155.6,123.8 105,160.7 124.5,101.2 73.7,64.5  136.4,64.6 155.6,5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "172.4,68 227,67.9 182.8,99.9 199.8,151.8 155.6,119.6 111.5,151.8 128.5,99.9 84.3,67.9 138.9,68  155.6,16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "155.6,27.1 169.9,71.4 216.5,71.3 178.8,98.6 193.3,142.8 155.6,115.4 118,142.8 132.5,98.6  94.8,71.3 141.3,71.4  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkaSaintPetersburg);
export default __webpack_public_path__ + "static/media/ska-saint-petersburg.df4fbc178bc2cc706c15fd8a92434681.svg";
export { ForwardRef as ReactComponent };